import { BusAlertConf } from './bus-alert-conf';

export class Bus {
  id: number;
  clientId: number;
  schoolId: number;
  assistantId: number;
  name: string;
  codeBus : string;
  brand: string;
  modelYear: string;
  matricule: string;
  iconeName: string;
  lat: number;
  lng: number;
  speed: number;
  time: string;
  angle: number;
  alertMouvement: number;
  gsmSignalStrength: number;
  extBattery: number;
  intBattery: number;
  infos: string;
  driverName: string;
  driverPhone: string;
  identifierPhone: string;
  withTracker: boolean;
  SMSPassengerActive: boolean;
  ShowPlanningParentsActive: boolean;
  consumption: string;
  mileage: number;
  offsetMileage: number;
  imei: number;
  sourceTypeTracker: string;
  simTracker: string;
  simExpiration: string;
  maxLoad: number;
  notificationAlertesIsValide: boolean;
  BusAlertConfs: any[];
  busStatus: string;
  colorLineBus: string;
  // client
  // school
  // busEvents
  // BusAlertConfs
  // positions
  // movingPositions
  // activityReports
  // passengers
  // passengerManualNotif

  constructor() {
    this.notificationAlertesIsValide = false;
    this.withTracker = true;
    this.BusAlertConfs = [];
    this.driverName = '';
    this.sourceTypeTracker = 'SOURCEPOWEREXT';
  }
}



// WEBPACK FOOTER //
// ./src/app/models/bus.ts